angular.module('cfn').factory('propertySupport', function() {
  var service = {};

  /**
   * Returns a sub property using a given path.
   *
   * @param{object} dataObject
   * @param {string} path The path to look for, e.g. "property1.property2"
   * @return {object} The object found at path or null if not found
   */
  service.deepGet = function(dataObject, path) {
    'use strict';
    var delimPos, next, remainingPath;

    // Base case of recursion: Last step not found
    if (dataObject == undefined || dataObject == null) {
      return undefined;
    }

    // Base case of recursion: No more steps to perform
    if (path.length === 0) {
      return dataObject;
    }

    // Recursion step
    delimPos = path.indexOf('.');
    if (delimPos > -1) {
      next = path.substr(0, delimPos);
      remainingPath = path.substr(delimPos + 1);
    } else {
      next = path;
      remainingPath = '';
    }
    return service.deepGet(dataObject[next], remainingPath);
  };

  return service;
});

angular.module('cfn').controller('dateFilterSelectorPopupController', [
  '$scope',
  '$rootScope',
  '$log',
  '$http',
  'dialog',
  'data',
  function($scope, $rootScope, $log, $http, dialog, data) {
    if (data.filter) $scope.filter = data.filter;
    $scope.options = data.options || {
      show: { day: true, timeFrame: true, none: true }
    };

    $scope.ok = function() {
      dialog.close({ result: 'ok', filter: $scope.filter });
    };

    $scope.cancel = function() {
      dialog.close({ result: 'cancel' });
    };

    $scope.onDateChange = function(dateFieldType) {
      if (dateFieldType === 'date') {
        $scope.filter.type = 'day';
      } else if (dateFieldType === 'startDate' || dateFieldType === 'endDate') {
        $scope.filter.type = 'timeFrame';
      }
    };

    return this;
  }
]);
